module.exports = __webpack_public_path__ + "static/media/Black logo.57b32ba4.png";